import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch", "error"];
import { useEffect } from 'react';
import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { usageTracker } from '../utils/usageTracker';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
const isAuthenticationFailedError = error => {
  let current = error;
  while (current) {
    if (current.reason === 'AUTHENTICATION_FAILED') {
      return true;
    }
    current = current.cause;
  }
  return false;
};
export const useLoginVerify = () => {
  const {
    isPreview
  } = getIsPreview();
  const _useLoginVerifyQuery = useLoginVerifyQuery({
      skip: isPreview,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId()
      }
    }),
    {
      data,
      loading,
      refetch,
      error
    } = _useLoginVerifyQuery,
    rest = _objectWithoutPropertiesLoose(_useLoginVerifyQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  const resolvedData = isPreview ? {
    email: 'preview@example.com'
  } : data;
  const email = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.email;
  useEffect(() => {
    if (email) {
      usageTracker.setProperties({
        email
      });
      // TODO: remove when migrated to Portals Platform earlyRequester
      usageTracker.track('Portals Platform', 'Portal Initialized', {});
    }
  }, [email]);
  const isForbidden = isAuthenticationFailedError(error);
  return Object.assign({
    data: resolvedData,
    refetch,
    loading: isPreview ? false : loading,
    error,
    isForbidden
  }, rest);
};